import React, { useEffect, useRef, useState } from "react";
import { MainContainer } from "../../components/Contents/Contents.element";
import { useTheme } from "../../contexts/ThemeContext";
import LoadingSpinner from "../../ui/LoadingSpinner";
import { useLoading } from "../../contexts/LoadingContext";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CustomButton from "../../ui/Button";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ResetIcon from "../../assets/icons/Reset.png";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import {
  BackToTeamChemistryBtn,
  MatchTrackContainer,
  ChemistryHeader,
  MatchTimeLineWrapper,
  IndividualStatContainer,
  VisNameContainer,
  PWBtnContainer,
} from "./StyledChemistryElements";
import {
  ChemistryPlayerPositions,
  IndividualPlayerStat,
  IPlayerData,
  ITeamSearch,
  OtherSquadMembers,
  PlayerFromSamePositions,
  SubstitutePlayer,
  TeamChemistry,
} from "../../types/IOption";
import { useSearch } from "../../contexts/PlayerSearchContext";
import {
  fetchAfterSubstitudeData,
  fetchAfterSwapData,
  fetchChemistryData,
  fetchEventTimeline,
  fetchFormationData,
  fetchHullData,
  fetchIndividualChemistry,
  fetchIndividualPassing,
  fetchMatchInformationData,
  fetchMatchTimeline,
  fetchMatchTimelineZoomLevel2,
  fetchOverallFormationData,
  fetchPlayerAttackPassData,
  fetchPlayerCardData,
  fetchPlayerPassingNetworks,
  fetchPlayersData,
  fetchPredictiveChemistryConnection,
  fetchRiskMapData,
  fetchSeasonData,
  fetchSubstituteOptions,
  fetchSwapablePlayerData,
  fetchTeamData,
  handleSearch,
} from "./Utils";
import { IPlayerSearchResponse } from "../../types/IPlayerSearchResponse";
import { ChemistryInfo, FormationSelectDrawer, PlayerSelectDrawer, SelectPlayerPassingAttackDrawer, TeamSelectDrawer } from "./UIContent";
import "./chemistry.css";
import SecondaryButton from "../../ui/SecondaryButton";
import LabelText from "../../ui/LabelText";
import LabelNumber from "../../styled-components/LabelNumber";
import PitchInfo from "../../components/PitchInfo";
import Pitch from "../../components/Pitch";
import Timeline, { SelectedData } from "../../components/Timeline";
import { CurrentPitchAxis, CurrentView } from "../../types/IPitchProps";
import MatchTimeLine from "../../components/MatchTimeline";
import Switch from "../../ui/CustomSwitch";
import { ITeamMatchByMonths } from "../../types/ITimeline";
import EventTimeLine from "../../components/EventTimeline";
import { FlowDataHash } from "../../@mc-playfield/Definations";
import { fetchFlowDataV1 } from "../../@mc-playfield/APIUtils";
import { IPassingAttackData } from "../../utils/drawPassingAttack";
import PWNotification from "../../components/PWNotification";
import { timelineVisRestrictions } from "./static";
import { IMatchEventCardData } from "../../types/IMatchEventCardData";
import MatchEventInfo from "../../components/MatchEventInfo";
import { PitchSidebar, PWSidebarBtns } from "../../ui/PWSidebarBtns";
import Simulate from "../../assets/icons/Simulate.png";
import SummaryBar from "../../components/SummaryBar";
import { usePitchWidgetContext } from "../../contexts/PitchWidgetContext";
import { BothPlayerImageContainer, PlayerImageContainer } from "../../components/PlayerInfo";
import { IPlayerCardDetail } from "../../types/IPlayerCardDetail";
import PlayerLandingCard from "../../ui/CardComponent";
import { useNotification } from "../../contexts/NotificationContext";

const TeamLayers: CurrentView[] = ["systemFit", "passingNetwork", "areasOfControl", "passingAttack", "minus"];
const PlayerLayers: CurrentView[] = ["flowOfPlay", "threatMap", "minus"];
const PitchAxisAlyer: CurrentPitchAxis[] = ["Pitch2D", "Pitch3D"];

export type ButtonKey = "play" | "previous" | "zoomIn" | "zoomOut" | "next";

const Chemistry: React.FC<{ toggle: boolean; isSubSidebarOpen: boolean; isHeader: boolean; teamId: number; isBlurred: boolean }> = (
  props
) => {
  const {
    selectedTeam,
    setSelectedTeam,
    selectedTeamLabel,
    setSelectedTeamLabel,
    currentView,
    setCurrentView,
    currentPlayView,
    setCurrentPlayView,
    positionResults,
    setPositionResults,
    formationData,
    setFormationData,
    teamChemistry,
    setTeamChemistry,
    selectedFormation,
    setSelectedFormation,
    passNetworkPlayers,
    setPassNetworkPlayers,
    passNetworkPlayerPasses,
    setPassNetworkPlayerPasses,
    PNFormationData,
    setPNFormationData,
    selectedPNFormation,
    setSelectedPNFormation,
    selectedMatch,
    setSelectedMatch,
    disabledButtons,
    setDisabledButtons,
    direction,
    setDirection,
    groupIndex,
    setGroupIndex,
    selectedSeasonId,
    setSelectedSeasonId,
    seasonName,
    setSeasonName,
    seasonData,
    setSeasonData,
    zoomLevelId,
    setZoomLevelId,
    timeLineTag,
    setTimeLineTag,
    injuryEvents,
    setInjuryEvents,
    matchLevelEvents,
    setMatchLevelEvents,
    matchEndTime,
    setMatchEndTime,
    matchDate,
    setMatchDate,
    matchInfo,
    setMatchInfo,
    previousMatchId,
    setPreviousMatchId,
    displayedMatches,
    setDisplayedMatches,
    matches,
    setMatches,
    riskMapData,
    setRiskMapData,
    hullData,
    setHullData,
    isIndividualChemistry,
    setIsIndividualChemistry,
    isIndividualPassing,
    setIsIndividualPassing,
    isSwapActive,
    setIsSwapActive,
    pnSwapActive,
    setPNSwapActive,
    isChemistryDataNotEnough,
    setIsChemistryDataNotEnough,
    individualHullPlayer,
    setIndividualHullPlayer,
    thirdOfSeason,
    setThirdOfSeason,
    drawCount,
    setDrawCount,
    lossCount,
    setLossCount,
    winCount,
    setWinCount,
    swappedPlayerClub,
    setSwappedPlayerClub,
    otherClubPlayer,
    setOtherClubPlayer,
    swappedPositionResults,
    setSwappedPositionResults,
    swappedTeamChemistry,
    setSwappedTeamChemistry,
    currentClubLogo,
    setCurrentClubLogo,
    playerToSwap,
    setPlayerToSwap,
    playerToSwapWith,
    setPlayerToSwapWith,
    currentPlayerView,
    setCurrentPlayerView,
    overallSFScore,
    setOverallSFScore,
    newOverallSFScore,
    setNewOverallSFScore,
    avgAge,
    setAvgAge,
    newAvgAge,
    setNewAvgAge,
    attackContribution,
    setAttackContribution,
    newAttackContribution,
    setNewAttackContribution,
    ppda,
    setPPDA,
    newPPDA,
    setNewPPDA,
  } = usePitchWidgetContext();

  const { displayCardNotification, seIsDisplayCardNotification, cardNotificationContent, setCardNotificationContent } = useNotification();
  const { theme } = useTheme();
  const { setSearchText, setSearchData, searchData, searchText } = useSearch();
  const inputRef = useRef<HTMLInputElement>(null);
  const { loading, startLoading, stopLoading } = useLoading();
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);
  const [optionsShow, setOptionsShow] = useState<boolean>(false);
  const [swapHoverPlayer, setSwapHoverPlayer] = useState<number>(0);
  const [swapPositionCode, setSwapPositionCode] = useState<string>("");
  const [sidebarPlayerShow, setSidebarPlayerShow] = useState<boolean>(false);
  const [informationShow, setInformationShow] = useState<boolean>(false);
  const [teams, setTeams] = useState<ITeamSearch[]>([]);
  const [sidebarFormationOpen, setSidebarFormationOpen] = useState<boolean>(false);
  const [playerPassingAttackOpen, setPlayerPassingAttackOpen] = useState<boolean>(false);
  const [isPerformancSwitchToggled, setIsPerformanceSwitchToggled] = useState<boolean>(false);
  const [isActualPositionToggled, setIsActualPositionToggled] = useState<boolean>(false);
  const [lastPositionResults, setLastPositionResults] = useState<ChemistryPlayerPositions[]>([]);
  const [lastTeamChemistry, setLastTeamChemistry] = useState<TeamChemistry[]>([]);
  const [otherSquadMembers, setOtherSquadMembers] = useState<OtherSquadMembers[]>([]);
  const [playerFromSamePositions, setPlayerFromSamePositions] = useState<PlayerFromSamePositions[]>([]);
  const [substitutePlayerOptions, setSubstitutePlayerOptions] = useState<SubstitutePlayer[]>([]);
  const [isReplacePlayer, setIsReplacePlayer] = useState<boolean>(false);
  const [individualStat, setIndividualStat] = useState<IndividualPlayerStat>();
  const [teamMatchesByMonth, setTeamMatchesByMonth] = useState<ITeamMatchByMonths[]>([]);
  const [playerCardID, setPlayerCardID] = useState<number>(0);
  const [playerCardDetails, setPlayerCardDeatils] = useState<IPlayerCardDetail | undefined>();
  const [alreadyPlottedPlayer, setAlreadyPlottedPlayer] = useState<{ playerID: number; xPosition: number; yPosition: number }>({
    playerID: 0,
    xPosition: 0,
    yPosition: 0,
  });
  const [timeLineDrawerOpen, setTimeLineDrawerOpen] = useState<boolean>(false);
  const [lastPassNetworkPlayers, setLastPassNetworkPlayers] = useState<ChemistryPlayerPositions[]>([]);
  const [lastPassNetworkPlayerPasses, setLastPassNetworkPlayerPasses] = useState<any[]>([]);
  const [isDisplayInitialRect, setIsDisplayInitialRect] = useState<boolean>(true);
  const [currentPitchAxis, setCurrentPitchAxis] = useState<CurrentPitchAxis>("Pitch2D");
  const [playerData, setPlayerData] = useState<IPlayerData[]>([]);
  const [flowData, setFlowData] = useState<FlowDataHash | undefined>(undefined);
  const [passingAttackPlayerId, setPassingAttackPlayerId] = useState<number>(0);
  const [passingAttackData, setPassingAttackData] = useState<IPassingAttackData[]>([]);
  const [sidebarHoverItem, setSidebarHoverItem] = useState<"leftUpper" | "leftLower" | "right">();
  const [isNotification, setIsNotification] = useState<boolean>(false);
  const [matchEventInfo, setMatchEventInfo] = useState<IMatchEventCardData | null>();
  const [isDisplayMatchEventInfo, setIsDisplayMatchEventInfo] = useState<boolean>(false);
  const playerCardRef = useRef(null);
  const matchesPerPage = 13;

  // Total number of groups
  const totalGroups = Math.ceil(matches.length / matchesPerPage);
  useEffect(() => {
    // Reset group index to 0 when match data changes
    setGroupIndex(0);
  }, [matches]);

  useEffect(() => {
    setIsSwapActive(false);
    setPlayerToSwap(0);
    setPlayerToSwapWith(0);
  }, [zoomLevelId, selectedSeasonId, selectedFormation, thirdOfSeason]);

  useEffect(() => {
    if (playerCardID > 0) {
      fetchPlayerCardData(startLoading, stopLoading, playerCardID, setPlayerCardDeatils);
    } else {
      setPlayerCardDeatils(undefined);
    }
  }, [playerCardID]);

  useEffect(() => {
    const teamChoosen = teams.filter((team) => Number(team.id) === selectedTeam);
    if (searchTerm.length >= 3 && teamChoosen[0]?.name !== searchTerm) {
      const teamChoosen = teams.filter((team) => Number(team.id) === selectedTeam);
      if (searchTerm.length >= 3 && teamChoosen[0]?.name !== searchTerm) {
        const getData = setTimeout(() => {
          fetchTeamData(searchTerm, setTeams);
        }, 400);
        return () => clearTimeout(getData);
      } else if (searchTerm.length === 0) {
        setTeams([]);
      }
    }
  }, [searchTerm]);

  useEffect(() => {
    const fetchData = async () => {
      if (
        currentView === "systemFit" &&
        selectedTeam > 0 &&
        positionResults.length === 0 &&
        (zoomLevelId === 2 || zoomLevelId === 3 || zoomLevelId === 4)
      ) {
        try {
          const matchIds = matches.map((match) => match.matchId);
          if (zoomLevelId === 4) {
            await fetchOverallFormationData(selectedTeam, setFormationData, setSelectedFormation);
          }
          await fetchChemistryData(
            selectedTeam,
            selectedSeasonId,
            setPositionResults,
            setTeamChemistry,
            startLoading,
            stopLoading,
            selectedFormation,
            setLastTeamChemistry,
            setLastPositionResults,
            setIsDisplayInitialRect,
            zoomLevelId === 4,
            matchIds,
            setIsChemistryDataNotEnough
          );
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    };
    fetchData();
  }, [currentView]);

  useEffect(() => {
    if (selectedTeam > 0 && selectedFormation > 0) {
      if (currentView === "systemFit") {
        setAlreadyPlottedPlayer({
          playerID: 0,
          xPosition: 0,
          yPosition: 0,
        });
      }
      if (currentView === "areasOfControl") {
        // setIndividualHullPlayer(0);
        fetchHullData(
          selectedTeam,
          selectedSeasonId,
          selectedFormation,
          matches.map((match: any) => match.matchId),
          setHullData,
          startLoading,
          stopLoading
        );
      }
    }
  }, [selectedFormation]);

  useEffect(() => {
    if (sidebarPlayerShow && selectedTeam > 0) {
      setPlayerToSwap(swapHoverPlayer);
      if (currentView === "systemFit") {
        fetchSwapablePlayerData(
          selectedTeam,
          setPlayerFromSamePositions,
          setOtherSquadMembers,
          startLoading,
          stopLoading,
          swapHoverPlayer,
          swapPositionCode,
          setSwapHoverPlayer,
          selectedSeasonId
        );
      }
      if (currentView === "passingNetwork") {
        fetchSubstituteOptions(
          selectedTeam,
          setSubstitutePlayerOptions,
          startLoading,
          stopLoading,
          swapHoverPlayer,
          swapPositionCode,
          selectedMatch,
          setSwapHoverPlayer
        );
      }
    }
  }, [sidebarPlayerShow]);

  useEffect(() => {
    fetchDataForTeam(selectedTeam.toString());

  }, [selectedTeam])

  const fetchMatchTimelineZoom2 = async (
    thirdOfSeason: string,
    isPrevious: boolean,
    isNext: boolean,
    newZoomLevel: number,
    team: number,
    seasonId?: number
  ) => {
    const currentSeasonId = seasonId ?? selectedSeasonId;
    await fetchMatchTimelineZoomLevel2(
      startLoading,
      team,
      setMatches,
      setDisabledButtons,
      setSelectedSeasonId,
      currentSeasonId,
      thirdOfSeason,
      isPrevious,
      isNext,
      newZoomLevel,
      setTimeLineTag,
      setSeasonName,
      async (updatedMatches, updatedSeasonId) => {
        const matchIds = updatedMatches.map((match) => match.matchId);
        if (currentView === "systemFit") {
          const selectedFormationId = await fetchFormationData(
            team,
            updatedSeasonId,
            startLoading,
            stopLoading,
            setFormationData,
            setSelectedFormation,
            matchIds
          );
          if (selectedFormationId !== null) {
            await fetchChemistryData(
              selectedTeam,
              updatedSeasonId,
              setPositionResults,
              setTeamChemistry,
              startLoading,
              stopLoading,
              selectedFormationId,
              setLastTeamChemistry,
              setLastPositionResults,
              setIsDisplayInitialRect,
              false,
              matchIds,
              setIsChemistryDataNotEnough
            );
          }
        }
        if (currentPlayView === "threatMap") {
          fetchRiskMapData(startLoading, stopLoading, updatedSeasonId, team, matchIds, setRiskMapData);
        }
        if (currentView === "areasOfControl") {
          setIndividualHullPlayer(0);
          fetchHullData(team, updatedSeasonId, selectedFormation, matchIds, setHullData, startLoading, stopLoading);
        }
        if (
          currentView === "passingNetwork" ||
          currentView === "optimalPathways" ||
          currentPlayView === "threatMap" ||
          currentPlayView === "flowOfPlay" ||
          currentView === "passingAttack" ||
          currentView === "minus"
        ) {
          stopLoading();
        }
      },
      setDrawCount,
      setLossCount,
      setWinCount
    );
  };
  const getNewZoomLevel = (currentZoomLevel: 1 | 2 | 3 | 4, buttonKey: ButtonKey): 1 | 2 | 3 | 4 => {
    switch (buttonKey) {
      case "zoomIn":
        return currentZoomLevel === 4 ? 3 : currentZoomLevel === 3 ? 2 : currentZoomLevel === 2 ? 1 : currentZoomLevel;
      case "zoomOut":
        return currentZoomLevel === 3 ? 4 : currentZoomLevel === 1 ? 2 : currentZoomLevel === 2 ? 3 : currentZoomLevel;
      case "previous":
      case "next":
        return currentZoomLevel === 2 ? 2 : currentZoomLevel;
      default:
        return currentZoomLevel;
    }
  };

  const handleZoomLevel3 = async (newZoomLevel: number, isPrevious: boolean, isNext: boolean, seasonId: number) => {
    const shouldFetchData = currentPlayView === "threatMap" || currentView === "areasOfControl" || currentView === "systemFit";
    const fetchData = async (updatedMatches: any[], updatedSeasonId: number) => {
      const matchIds = updatedMatches.map((match) => match.matchId);
      if (currentView === "systemFit" && selectedTeam > 1) {
        const newFormationId = await fetchFormationData(
          selectedTeam,
          updatedSeasonId,
          startLoading,
          stopLoading,
          setFormationData,
          setSelectedFormation,
          matchIds
        );
        await fetchChemistryData(
          selectedTeam,
          updatedSeasonId,
          setPositionResults,
          setTeamChemistry,
          startLoading,
          stopLoading,
          newFormationId!,
          setLastTeamChemistry,
          setLastPositionResults,
          setIsDisplayInitialRect,
          false,
          matchIds,
          setIsChemistryDataNotEnough
        );
      }
      if (currentPlayView === "threatMap") {
        await fetchRiskMapData(startLoading, stopLoading, updatedSeasonId, selectedTeam, zoomLevelId === 3 ? [] : matchIds, setRiskMapData);
      }
      if (currentView === "areasOfControl") {
        setIndividualHullPlayer(0);
        await fetchHullData(
          selectedTeam,
          updatedSeasonId,
          selectedFormation,
          matchIds.length ? matchIds : null,
          setHullData,
          startLoading,
          stopLoading
        );
      }
    };

    await fetchMatchTimeline(
      startLoading,
      stopLoading,
      selectedTeam,
      setMatches,
      setDisabledButtons,
      setSelectedSeasonId,
      seasonId,
      isPrevious,
      isNext,
      newZoomLevel,
      setTeamMatchesByMonth,
      setTimeLineTag,
      setSeasonName,
      false,
      shouldFetchData ? fetchData : undefined
    );
  };
  const handleZoomLevel2 = async (newZoomLevel: number, isPrevious: boolean, isNext: boolean) => {
    setSelectedMatch(0);
    let newThirdOfSeason = thirdOfSeason;
    if (isPrevious) {
      newThirdOfSeason = thirdOfSeason === "FinalThird" ? "MiddleThird" : thirdOfSeason === "MiddleThird" ? "FirstThird" : thirdOfSeason;
    } else if (isNext) {
      newThirdOfSeason = thirdOfSeason === "FirstThird" ? "MiddleThird" : thirdOfSeason === "MiddleThird" ? "FinalThird" : thirdOfSeason;
    }
    setThirdOfSeason(newThirdOfSeason);
    await fetchMatchTimelineZoom2(newThirdOfSeason, isPrevious, isNext, newZoomLevel, selectedTeam);
    setPreviousMatchId(selectedMatch);
  };
  const handleZoomLevel1 = async (isPrevious: boolean, isNext: boolean, matchId?: number) => {
    let MatchId: number = 0;
    let PlayerId: number = 0;
    await fetchEventTimeline(
      startLoading,
      stopLoading,
      selectedTeam,
      matchId ?? selectedMatch,
      setInjuryEvents,
      setMatchEndTime,
      setMatchLevelEvents,
      setMatchInfo,
      setSelectedMatch,
      setTimeLineTag,
      setDisabledButtons,
      isPrevious,
      isNext,
      setMatchDate,
      (updatedMatchId) => {
        MatchId = updatedMatchId;
      }
    );
    await fetchPlayersData(startLoading, stopLoading, selectedTeam, MatchId ?? 0, setPlayerData, (playerData) => {
      const playerExists = playerData.some((player) => player.value === passingAttackPlayerId);
      if (playerExists) {
        PlayerId = playerData.find((player) => player.value === passingAttackPlayerId)?.value ?? 0;
      } else {
        setPassingAttackPlayerId(0);
        setPassingAttackData([]);
      }
    });

    if (currentPlayView === "flowOfPlay") {
      setIsNotification(false);
      setCurrentView("minus");
      await fetchFlowDataV1(startLoading, stopLoading, 0, selectedTeam, true, MatchId, true, setFlowData);
      if (isActualPositionToggled) {
        await fetchPlayerPassingNetworks(
          selectedTeam,
          MatchId ?? 0,
          selectedPNFormation,
          startLoading,
          stopLoading,
          isActualPositionToggled,
          setPassNetworkPlayers,
          setPassNetworkPlayerPasses,
          setLastPassNetworkPlayers,
          setLastPassNetworkPlayerPasses
        );
      } else {
        const formationId = await fetchFormationData(
          selectedTeam,
          selectedSeasonId,
          startLoading,
          stopLoading,
          setPNFormationData,
          setSelectedPNFormation,
          [MatchId],
          true
        );
        await fetchPlayerPassingNetworks(
          selectedTeam,
          MatchId ?? 0,
          formationId ?? selectedPNFormation,
          startLoading,
          stopLoading,
          isActualPositionToggled,
          setPassNetworkPlayers,
          setPassNetworkPlayerPasses,
          setLastPassNetworkPlayers,
          setLastPassNetworkPlayerPasses
        );
      }
    } else if (currentView === "passingNetwork") {
      setCurrentView("passingNetwork");
      setCurrentPlayView("minus");
      setSelectedPNFormation(0);
      // await fetchPlayersData(startLoading, stopLoading, selectedTeam, MatchId ?? 0, setPlayerData);
      if (isActualPositionToggled) {
        await fetchPlayerPassingNetworks(
          selectedTeam,
          MatchId ?? 0,
          selectedPNFormation,
          startLoading,
          stopLoading,
          isActualPositionToggled,
          setPassNetworkPlayers,
          setPassNetworkPlayerPasses,
          setLastPassNetworkPlayers,
          setLastPassNetworkPlayerPasses
        );
      } else {
        setPNSwapActive(false);
        setIsIndividualPassing(false);
        const formationId = await fetchFormationData(
          selectedTeam,
          selectedSeasonId,
          startLoading,
          stopLoading,
          setPNFormationData,
          setSelectedPNFormation,
          [MatchId],
          true
        );
        await fetchPlayerPassingNetworks(
          selectedTeam,
          MatchId ?? 0,
          formationId ?? selectedPNFormation,
          startLoading,
          stopLoading,
          isActualPositionToggled,
          setPassNetworkPlayers,
          setPassNetworkPlayerPasses,
          setLastPassNetworkPlayers,
          setLastPassNetworkPlayerPasses
        );
      }
    } else if (currentView === "passingAttack") {
      if (PlayerId > 0) fetchPlayerAttackPassData(startLoading, stopLoading, PlayerId, MatchId, setPassingAttackData);
    }
  };
  const toggleButtonState = async (buttonKey: ButtonKey) => {
    const newZoomLevel = getNewZoomLevel(zoomLevelId, buttonKey);
    setDirection(buttonKey === "previous" ? "previous" : "next");
    switch (newZoomLevel) {
      case 4:
        await fetchOverallFormationData(selectedTeam, setFormationData, setSelectedFormation);
        await fetchChemistryData(
          selectedTeam,
          0,
          setPositionResults,
          setTeamChemistry,
          startLoading,
          stopLoading,
          0,
          setLastTeamChemistry,
          setLastPositionResults,
          setIsDisplayInitialRect,
          true,
          [],
          setIsChemistryDataNotEnough,
          setFormationData,
          setSelectedFormation
        );
        setMatches([]);
        setZoomLevelId(newZoomLevel);
        setDisabledButtons((prevState) => ({
          ...prevState,
          play: true,
          previous: true,
          next: true,
          zoomIn: false,
          zoomOut: true,
        }));
        break;
      case 3:
        await handleZoomLevel3(newZoomLevel, buttonKey === "previous", buttonKey === "next", selectedSeasonId);
        setZoomLevelId(newZoomLevel);
        break;
      case 2:
        await handleZoomLevel2(newZoomLevel, buttonKey === "previous", buttonKey === "next");
        // setTimeout(()=>{
        setZoomLevelId(newZoomLevel);
        setDirection(buttonKey === "previous" ? "previous" : "next");
        setMatchEventInfo(null);
        setIsDisplayMatchEventInfo(false);
        // },3000)
        break;
      case 1:
        await handleZoomLevel1(buttonKey === "previous", buttonKey === "next");
        // setTimeout(()=>{
        setZoomLevelId(newZoomLevel);
        setDirection(buttonKey === "previous" ? "previous" : "next");
        // },3000)
        break;
      default:
        await handleZoomLevel1(buttonKey === "previous", buttonKey === "next");
        // setTimeout(()=>{
        setZoomLevelId(newZoomLevel);
        setDirection(buttonKey === "previous" ? "previous" : "next");
        // },3000)
        break;
    }
  };
  const handleSwitchClick = (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    event.stopPropagation();
    setIsPerformanceSwitchToggled((prev) => !prev);
  };
  const handleActualPositionSwitchClick = (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    event.stopPropagation();
    setIsActualPositionToggled((prev) => !prev);
    setIsIndividualPassing(false);
    setPNSwapActive(false);
    if (isActualPositionToggled) {
      fetchFormationData(
        selectedTeam,
        selectedSeasonId,
        startLoading,
        stopLoading,
        setPNFormationData,
        setSelectedPNFormation,
        [selectedMatch],
        true
      );
      startLoading();
      fetchPlayerPassingNetworks(
        selectedTeam,
        selectedMatch,
        selectedPNFormation,
        startLoading,
        stopLoading,
        false,
        setPassNetworkPlayers,
        setPassNetworkPlayerPasses,
        setLastPassNetworkPlayers,
        setLastPassNetworkPlayerPasses
      );
    } else {
      setPNFormationData([]);
      fetchPlayerPassingNetworks(
        selectedTeam,
        selectedMatch,
        selectedPNFormation,
        startLoading,
        stopLoading,
        true,
        setPassNetworkPlayers,
        setPassNetworkPlayerPasses,
        setLastPassNetworkPlayers,
        setLastPassNetworkPlayerPasses
      );
    }
  };

  // const memoizedDisplayedMatches = useMemo(() => {
  //   const reversedMatches = matches.slice().reverse(); // Reverse the order of matches
  //   const startIndex = groupIndex * matchesPerPage;
  //   const endIndex = startIndex + matchesPerPage;
  //   return reversedMatches.slice(startIndex, endIndex)//.reverse();
  // }, [matches, groupIndex, matchesPerPage]);

  useEffect(() => {
    const reversedMatches = matches.slice().reverse(); // Reverse the order of matches
    const startIndex = groupIndex * matchesPerPage;
    const endIndex = startIndex + matchesPerPage;
    let newDisplayedMatches;
    if (matches.length < matchesPerPage) {
      newDisplayedMatches = reversedMatches.slice(startIndex, endIndex);
    } else {
      const rever = reversedMatches.reverse().slice(startIndex, endIndex);
      newDisplayedMatches = rever.reverse();
    }
    // const newDisplayedMatches = matches.length < matchesPerPage ?
    //   reversedMatches.slice(startIndex, endIndex)
    //   : reversedMatches.reverse().slice(startIndex, endIndex);

    setDisplayedMatches(newDisplayedMatches);
  }, [matches, groupIndex, matchesPerPage]);

  const handlePNFormationChange = (formationId: number) => {
    setSelectedPNFormation(formationId);
    setPNSwapActive(false);
    setIsIndividualPassing(false);
    startLoading();
    fetchPlayerPassingNetworks(
      selectedTeam,
      selectedMatch,
      formationId,
      startLoading,
      stopLoading,
      isActualPositionToggled,
      setPassNetworkPlayers,
      setPassNetworkPlayerPasses,
      setLastPassNetworkPlayers,
      setLastPassNetworkPlayerPasses
    ).finally(stopLoading);
  };
  const fetchMatchInformation = async () => {
    if (isDisplayMatchEventInfo) {
      setIsDisplayMatchEventInfo(false);
    } else {
      fetchMatchInformationData(selectedMatch, startLoading, stopLoading, setMatchEventInfo, setMatchDate, (matchEventData) => {
        matchEventData !== null && setIsDisplayMatchEventInfo(true);
      });
    }
  };
  const handleLeftClick = () => {
    setGroupIndex((prevIndex) => Math.min(prevIndex + 1, totalGroups - 1));
  };

  // Handle right button click
  const handleRightClick = () => {
    setGroupIndex((prevIndex) => Math.max(prevIndex - 1, 0));
  };

  const handleReset = async () => {
    if (selectedTeam > 0) {
      if (currentView === "systemFit") {
        setIsIndividualChemistry(false);
        setAlreadyPlottedPlayer({
          playerID: 0,
          xPosition: 0,
          yPosition: 0,
        });
        if (lastPositionResults.length > 0 && otherClubPlayer === 0) {
          setPositionResults(lastPositionResults);
          setTeamChemistry(lastTeamChemistry);
          setLastTeamChemistry([]);
          setLastPositionResults([]);
        } else {
          setIsSwapActive(false);
          setSwappedTeamChemistry([]);
          setSwappedPositionResults([]);
          setSwappedPlayerClub("");
          setCurrentPlayerView(0);
          setPlayerToSwap(0);
          setPlayerToSwapWith(0);
          setOtherClubPlayer(0);
          const matchIds = matches.map((match) => match.matchId);
          if (zoomLevelId === 4) {
            await fetchOverallFormationData(selectedTeam, setFormationData, setSelectedFormation);
          }
          await fetchChemistryData(
            selectedTeam,
            selectedSeasonId,
            setPositionResults,
            setTeamChemistry,
            startLoading,
            stopLoading,
            selectedFormation,
            setLastTeamChemistry,
            setLastPositionResults,
            setIsDisplayInitialRect,
            zoomLevelId === 4 ? true : false,
            matchIds,
            setIsChemistryDataNotEnough
          );
        }
      }
      if (currentView === "passingNetwork") {
        setIsIndividualPassing(false);
        if (lastPassNetworkPlayers.length > 0 && lastPassNetworkPlayerPasses.length > 0) {
          setPassNetworkPlayers(lastPassNetworkPlayers);
          setPassNetworkPlayerPasses(lastPassNetworkPlayerPasses);
          setLastPassNetworkPlayers([]);
          setLastPassNetworkPlayerPasses([]);
        } else {
          setPNSwapActive(false);
          fetchPlayerPassingNetworks(
            selectedTeam,
            selectedMatch,
            selectedPNFormation,
            startLoading,
            stopLoading,
            isActualPositionToggled,
            setPassNetworkPlayers,
            setPassNetworkPlayerPasses,
            setLastPassNetworkPlayers,
            setLastPassNetworkPlayerPasses
          );
        }
      }
    }
  };
  const handleSwapPlayer = async (
    playerToSwapWith: number,
    playerToGoOut?: number,
    swapPosition?: string,
    secondSwapPlayer?: ChemistryPlayerPositions
  ) => {
    if (!secondSwapPlayer) {
      const playerAlready = positionResults.filter((player) => player.playerId === playerToSwapWith);
      if (playerAlready?.length === 1) {
        setAlreadyPlottedPlayer({
          playerID: playerAlready[0].playerId,
          xPosition: playerAlready[0].xCoordinate,
          yPosition: playerAlready[0].yCoordinate,
        });
      } else {
        setAlreadyPlottedPlayer({
          playerID: 0,
          xPosition: 0,
          yPosition: 0,
        });
      }
    }
    if (playerToSwapWith > 0 && selectedFormation > 0) {
      if (currentView === "systemFit") {
        setIsSwapActive(true);
        setIsIndividualChemistry(false);
        setPlayerToSwapWith(playerToSwapWith);
        setCurrentPlayerView(playerToSwapWith);
        const positionResultsFromResponse = await fetchAfterSwapData(
          startLoading,
          stopLoading,
          playerToGoOut ? playerToGoOut : playerToSwap,
          playerToSwapWith,
          swapPosition ? swapPosition : swapPositionCode,
          selectedFormation,
          positionResults,
          teamChemistry,
          setPositionResults,
          setTeamChemistry,
          setSwappedPositionResults,
          setSwappedTeamChemistry,
          selectedTeam,
          zoomLevelId === 4 ? true : false,
          selectedSeasonId,
          matches.map((match) => match.matchId)
        );
        if (positionResultsFromResponse?.length! > 1 && secondSwapPlayer) {
          const newPositionResults = await fetchAfterSwapData(
            startLoading,
            stopLoading,
            playerToSwapWith,
            playerToGoOut ? playerToGoOut : playerToSwap,
            secondSwapPlayer?.positionCode!,
            selectedFormation,
            [
              ...positionResults.filter((player) => player?.playerId !== 0),
              positionResultsFromResponse?.find((player) => player?.playerId === secondSwapPlayer?.playerId)!,
            ],
            teamChemistry,
            setPositionResults,
            setTeamChemistry,
            setSwappedPositionResults,
            setSwappedTeamChemistry,
            selectedTeam,
            zoomLevelId === 4 ? true : false,
            selectedSeasonId,
            matches.map((match) => match.matchId)
          );
          setPositionResults(newPositionResults!.filter((player) => player?.playerId !== 0));
          setTeamChemistry(teamChemistry?.filter((connection) => connection?.score !== null));
        }
      }
      if (currentView === "passingNetwork") {
        setPNSwapActive(true);
        fetchAfterSubstitudeData(
          startLoading,
          stopLoading,
          selectedTeam,
          selectedMatch,
          playerToSwap,
          playerToSwapWith,
          swapPositionCode,
          selectedPNFormation,
          passNetworkPlayers,
          setPassNetworkPlayers,
          setPassNetworkPlayerPasses,
          isActualPositionToggled
        );
      }
    }
    setSidebarPlayerShow(false);
  };
  const handleIndividualChemistry = (playerID: number, positionCode: string) => {
    setIndividualStat(undefined);
    setAlreadyPlottedPlayer({
      playerID: 0,
      xPosition: 0,
      yPosition: 0,
    });
    setIsIndividualChemistry(true);
    setIsSwapActive(false);
    setLastTeamChemistry(teamChemistry);
    setLastPositionResults(positionResults);
    fetchIndividualChemistry(
      startLoading,
      stopLoading,
      playerID,
      positionCode,
      setPositionResults,
      setTeamChemistry,
      positionResults,
      selectedFormation,
      zoomLevelId === 4 ? true : false,
      selectedTeam,
      selectedSeasonId,
      matches.map((match) => match.matchId)
    );
  };
  const handleIndividualPassing = (playerID: number) => {
    setPNSwapActive(false);
    setIsIndividualPassing(true);
    setLastPassNetworkPlayers(passNetworkPlayers);
    setLastPassNetworkPlayerPasses(passNetworkPlayerPasses);
    fetchIndividualPassing(
      startLoading,
      stopLoading,
      selectedTeam,
      selectedMatch,
      playerID,
      setPassNetworkPlayers,
      setPassNetworkPlayerPasses,
      setIndividualStat,
      passNetworkPlayers,
      selectedFormation,
      isActualPositionToggled
    );
  };

  const handleSearchChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    handleSearch(event, setSearchText, startLoading, setSearchData, stopLoading);
  };
  const handleClear = () => {
    setSearchText("");
    setSearchData?.([]);
  };
  const handleClose = () => {
    setSearchText("");
    setSearchData?.([]);
  };
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };
  const handleTeamClear = () => {
    setSearchTerm("");
  };
  const handleInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    e.stopPropagation();
  };
  const resetSelections = () => {
    setSelectedSeasonId(0);
    setZoomLevelId(4);
    setPlayerCardID(0);
    setTeamChemistry([]);
    setPositionResults([]);
    setPassNetworkPlayerPasses([]);
    setPassNetworkPlayers([]);
    setSelectedMatch(0);
    setSelectedFormation(0);
    setSelectedPNFormation(0);
  };
  const updateTeamSelections = (team: string, teamId: string) => {
    setSearchTerm(team);
    const teamChosen = teams.find((team) => team.id === teamId);
    if (teamChosen) {
      setSelectedTeam(Number(teamChosen.id));
      setSelectedTeamLabel(team);
      setCurrentClubLogo(teamChosen.logoURL);
    }
  };
  const fetchDataForTeam = async (teamId: string) => {
    const id = Number(teamId);
    startLoading();
    try {
      await Promise.all([
        //  fetchMatchTimelineZoom2(thirdOfSeason, false, false, 2, id, 0),
        fetchSeasonData(startLoading, stopLoading, id, setSeasonData),
      ]);
    } catch (error) {
      console.error("Error fecthcing data from team:", error);
    } finally {
      stopLoading();
    }
  };

  const handleFormationChange = async (formationId: number) => {
    if (selectedTeam > 0 && formationId > 0) {
      if (currentView === "systemFit") {
        setAlreadyPlottedPlayer({
          playerID: 0,
          xPosition: 0,
          yPosition: 0,
        });
        setIsSwapActive(false);
        setIsIndividualChemistry(false);
        const matchIds = matches.map((match) => match.matchId);
        fetchChemistryData(
          selectedTeam,
          selectedSeasonId,
          setPositionResults,
          setTeamChemistry,
          startLoading,
          stopLoading,
          formationId,
          setLastTeamChemistry,
          setLastPositionResults,
          setIsDisplayInitialRect,
          zoomLevelId === 4 ? true : false,
          matchIds,
          setIsChemistryDataNotEnough
        );
      }
      if (currentView === "areasOfControl") {
        setIndividualHullPlayer(0);
        fetchHullData(
          selectedTeam,
          selectedSeasonId,
          formationId,
          matches.map((match: any) => match.matchId),
          setHullData,
          startLoading,
          stopLoading
        );
      }
    }
  };

  const handleTeamChange = async (team: string, teamId: string) => {
    setSidebarOpen(false);
    resetSelections();
    setSearchTerm(team);
    setFlowData(undefined);
    setZoomLevelId(4);
    setMatches([]);
    // setCurrentView("systemFit");
    // setCurrentPlayView("minus");
    await updateTeamSelections(team, teamId);
    const matchIds = matches.map((match) => match.matchId);
    await fetchOverallFormationData(Number(teamId), setFormationData, setSelectedFormation);
    await fetchChemistryData(
      Number(teamId),
      0,
      setPositionResults,
      setTeamChemistry,
      startLoading,
      stopLoading,
      0,
      setLastTeamChemistry,
      setLastPositionResults,
      setIsDisplayInitialRect,
      true,
      matchIds,
      setIsChemistryDataNotEnough,
      setFormationData,
      setSelectedFormation
    );
    setDisabledButtons((prevState) => ({
      ...prevState,
      play: true,
      previous: true,
      next: true,
      zoomIn: false,
      zoomOut: true,
    }));
    await fetchDataForTeam(teamId);
  };
  const handleSelect = (item: IPlayerSearchResponse | IPlayerSearchResponse[] | null, selected: boolean) => {
    if (Array.isArray(item) && item.length > 0) {
      handleSwapPlayer(item[0].playerId);
      setSwappedPlayerClub(item[0].playerClubURL);
      setOtherClubPlayer(item[0].playerId);
      handleClose();
    }
  };

  const handleConfirm = async (selectedData: SelectedData) => {
    const { zoomLevelId, seasonId, selectedOption, matchId, overall } = selectedData;
    setZoomLevelId(zoomLevelId);
    setSelectedSeasonId(seasonId);
    setThirdOfSeason(selectedOption!!);
    if (overall) {
      await fetchOverallFormationData(selectedTeam, setFormationData, setSelectedFormation);
      await fetchChemistryData(
        selectedTeam,
        0,
        setPositionResults,
        setTeamChemistry,
        startLoading,
        stopLoading,
        0,
        setLastTeamChemistry,
        setLastPositionResults,
        setIsDisplayInitialRect,
        true,
        [],
        setIsChemistryDataNotEnough
      );
      setMatches([]);
      setDisabledButtons({
        play: true,
        previous: true,
        zoomOut: true,
        zoomIn: false,
        next: true,
      });
      //setIsNotification(false);
      //setNotificationContent('');
    } else {
      if (zoomLevelId === 2) fetchMatchTimelineZoom2(selectedData.selectedOption!!, false, false, 2, selectedTeam, selectedData.seasonId);
      else if (zoomLevelId === 3) handleZoomLevel3(zoomLevelId, false, false, selectedData.seasonId);
      else if (zoomLevelId === 1) {
        if (currentView === "passingNetwork") {
          handleZoomLevel1(false, false, matchId);
          fetchEventTimeline(
            startLoading,
            stopLoading,
            selectedTeam,
            matchId,
            setInjuryEvents,
            setMatchEndTime,
            setMatchLevelEvents,
            setMatchInfo,
            setSelectedMatch,
            setTimeLineTag,
            setDisabledButtons,
            false,
            false,
            setMatchDate
          );
        } else {
          fetchEventTimeline(
            startLoading,
            stopLoading,
            selectedTeam,
            matchId,
            setInjuryEvents,
            setMatchEndTime,
            setMatchLevelEvents,
            setMatchInfo,
            setSelectedMatch,
            setTimeLineTag,
            setDisabledButtons,
            false,
            false,
            setMatchDate
          );
        }
      }
      if (isDisplayMatchEventInfo) {
        fetchMatchInformationData(matchId, startLoading, stopLoading, setMatchEventInfo, setMatchDate, (matchEventData) => {
          matchEventData !== null && setIsDisplayMatchEventInfo(true);
        });
      }
    }
  };

  const handlePlayerSelection = (playerId: number) => {
    if (currentView === "passingAttack") {
      fetchPlayerAttackPassData(startLoading, stopLoading, playerId, selectedMatch, setPassingAttackData);
    }
  };

  function convertToTitleCase(text: string) {
    const currentText = text === "chemistryNetwork" ? "systemFit" : text === "minus" ? currentPlayView : text;
    const words = currentText.split(/([A-Z][a-z]+)/); // Split on camelCase word boundaries
    return words.map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
  }
  const handleSelectMatch = async (matchId: number) => {
    try {
      startLoading();
      const selectedMatchId = await fetchEventTimeline(
        startLoading,
        stopLoading,
        selectedTeam,
        matchId,
        setInjuryEvents,
        setMatchEndTime,
        setMatchLevelEvents,
        setMatchInfo,
        setSelectedMatch,
        setTimeLineTag,
        setDisabledButtons,
        false,
        false,
        setMatchDate
      );
      await fetchPlayersData(startLoading, stopLoading, selectedTeam, matchId ?? 0, setPlayerData);
      setSelectedMatch(matchId);
      setZoomLevelId(1);
      if (currentPlayView === "flowOfPlay") {
        setCurrentView("minus");
        setIsNotification(false);
        await fetchFlowDataV1(startLoading, stopLoading, 0, selectedTeam, true, matchId, true, setFlowData);
        if (isActualPositionToggled) {
          await fetchPlayerPassingNetworks(
            selectedTeam,
            matchId ?? 0,
            selectedPNFormation,
            startLoading,
            stopLoading,
            isActualPositionToggled,
            setPassNetworkPlayers,
            setPassNetworkPlayerPasses,
            setLastPassNetworkPlayers,
            setLastPassNetworkPlayerPasses
          );
        } else {
          const formationId = await fetchFormationData(
            selectedTeam,
            selectedSeasonId,
            startLoading,
            stopLoading,
            setPNFormationData,
            setSelectedPNFormation,
            [matchId],
            true
          );
          await fetchPlayerPassingNetworks(
            selectedTeam,
            matchId ?? 0,
            formationId !== null ? formationId : selectedPNFormation,
            startLoading,
            stopLoading,
            isActualPositionToggled,
            setPassNetworkPlayers,
            setPassNetworkPlayerPasses,
            setLastPassNetworkPlayers,
            setLastPassNetworkPlayerPasses
          );
          stopLoading();
        }
      } else if (currentView === "passingNetwork") {
        setCurrentView("passingNetwork");
        setCurrentPlayView("minus");
        setIsNotification(false);
        setSelectedPNFormation(0);
        if (isActualPositionToggled) {
          await fetchPlayerPassingNetworks(
            selectedTeam,
            matchId ?? 0,
            selectedPNFormation,
            startLoading,
            stopLoading,
            isActualPositionToggled,
            setPassNetworkPlayers,
            setPassNetworkPlayerPasses,
            setLastPassNetworkPlayers,
            setLastPassNetworkPlayerPasses
          );
        } else {
          setPNSwapActive(false);
          setIsIndividualPassing(false);
          const formationId = await fetchFormationData(
            selectedTeam,
            selectedSeasonId,
            startLoading,
            stopLoading,
            setPNFormationData,
            setSelectedPNFormation,
            [matchId],
            true
          );
          await fetchPlayerPassingNetworks(
            selectedTeam,
            matchId ?? 0,
            formationId !== null ? formationId : selectedPNFormation,
            startLoading,
            stopLoading,
            isActualPositionToggled,
            setPassNetworkPlayers,
            setPassNetworkPlayerPasses,
            setLastPassNetworkPlayers,
            setLastPassNetworkPlayerPasses
          );
          stopLoading();
        }
      }
    } catch (error) {
      stopLoading();
      console.error("Error fetching data: ", error);
    }
  };

  const handleCurrentView = async (currentView: CurrentView) => {
    setCurrentView(currentView);
    if (currentView !== "minus") {
      setCurrentPlayView("minus");
    }
    if (currentView === "threatMap" && selectedTeam > 0) {
      const matchIds = zoomLevelId === 3 ? [] : matches.map((match) => match.matchId);
      fetchRiskMapData(startLoading, stopLoading, selectedSeasonId, selectedTeam, matchIds, setRiskMapData);
    }
    if (currentView === "areasOfControl" && selectedTeam > 0 && (zoomLevelId === 2 || zoomLevelId === 3)) {
      const matchIds = zoomLevelId === 3 ? [] : matches.map((match) => match.matchId);
      fetchHullData(selectedTeam, selectedSeasonId, selectedFormation, matchIds, setHullData, startLoading, stopLoading);
    }
    if (currentView === "passingNetwork" && selectedMatch > 0 && zoomLevelId === 1) {
      if (isActualPositionToggled) {
        await fetchPlayerPassingNetworks(
          selectedTeam,
          selectedMatch,
          selectedPNFormation,
          startLoading,
          stopLoading,
          isActualPositionToggled,
          setPassNetworkPlayers,
          setPassNetworkPlayerPasses,
          setLastPassNetworkPlayers,
          setLastPassNetworkPlayerPasses
        );
      } else {
        setPNSwapActive(false);
        setIsIndividualPassing(false);
        const formationId = await fetchFormationData(
          selectedTeam,
          selectedSeasonId,
          startLoading,
          stopLoading,
          setPNFormationData,
          setSelectedPNFormation,
          [selectedMatch],
          true
        );
        await fetchPlayerPassingNetworks(
          selectedTeam,
          selectedMatch,
          formationId !== null ? formationId : selectedPNFormation,
          startLoading,
          stopLoading,
          isActualPositionToggled,
          setPassNetworkPlayers,
          setPassNetworkPlayerPasses,
          setLastPassNetworkPlayers,
          setLastPassNetworkPlayerPasses
        );
        stopLoading();
      }
    }
    if (currentView === "passingAttack" && selectedMatch > 0 && passingAttackPlayerId > 0) {
      fetchPlayerAttackPassData(startLoading, stopLoading, passingAttackPlayerId, selectedMatch, setPassingAttackData);
    }
    if (
      currentView === "systemFit" &&
      teamChemistry.length < 1 &&
      selectedTeam > 1 &&
      selectedFormation > 0 &&
      (zoomLevelId === 2 || zoomLevelId === 3 || zoomLevelId === 4)
    ) {
      // fetchFormationData(selectedTeam, selectedSeasonId, startLoading, stopLoading, setFormationData, setSelectedFormation);
      const matchIds = matches.map((match) => match.matchId);
      if (zoomLevelId === 4) {
        await fetchOverallFormationData(selectedTeam, setFormationData, setSelectedFormation);
      }
      await fetchChemistryData(
        selectedTeam,
        selectedSeasonId,
        setPositionResults,
        setTeamChemistry,
        startLoading,
        stopLoading,
        selectedFormation,
        setLastTeamChemistry,
        setLastPositionResults,
        setIsDisplayInitialRect,
        zoomLevelId === 4 ? true : false,
        matchIds,
        setIsChemistryDataNotEnough
      );
    }
  };

  const handleCurrentPlayView = (currentView: CurrentView) => {
    setCurrentPlayView(currentView);
    if (currentView !== "minus") {
      setCurrentView("minus");
    }
    if (currentView === "threatMap" && selectedTeam > 0) {
      const matchIds = zoomLevelId === 3 ? [] : matches.map((match) => match.matchId);
      fetchRiskMapData(startLoading, stopLoading, selectedSeasonId, selectedTeam, matchIds, setRiskMapData);
    }
    if (currentView === "flowOfPlay") {
      if (zoomLevelId === 1 && selectedTeam > 0) {
        setCurrentView("minus");
        fetchFlowDataV1(startLoading, stopLoading, 0, selectedTeam, true, selectedMatch, true, setFlowData);
      } else {
        setIsNotification(true);
      }
    }
  };

  const [notificationContent, setNotificationContent] = useState<string>("");

  useEffect(() => {
    if (
      timelineVisRestrictions[currentView][zoomLevelId] !== "allow" ||
      timelineVisRestrictions[currentPlayView][zoomLevelId] !== "allow"
    ) {
      setIsNotification(true);
      if (currentView === "passingNetwork") {
        setPassNetworkPlayerPasses([]);
        setIsIndividualPassing(false);
        setPNSwapActive(false);
        setPNFormationData([]);
        if (zoomLevelId === 2 || zoomLevelId === 3 || zoomLevelId === 4) {
          setPassNetworkPlayers(positionResults);
        }
      }
      if (currentView === "areasOfControl") {
        setHullData([]);
      }
      if (currentView === "systemFit") {
        setTeamChemistry([]);
        setIsIndividualChemistry(false);
        setIsSwapActive(false);
        setIsChemistryDataNotEnough(false);
      }
      if (currentView === "minus") {
        setNotificationContent(timelineVisRestrictions[currentPlayView][zoomLevelId]);
      } else {
        setNotificationContent(timelineVisRestrictions[currentView][zoomLevelId]);
      }
      if (currentPlayView === "flowOfPlay") {
        setFlowData(undefined);
        if (zoomLevelId === 2 || zoomLevelId === 3 || zoomLevelId === 4) {
          setPassNetworkPlayers(positionResults);
        }
      }
    } else {
      setIsNotification(false);
    }
  }, [currentView, currentPlayView, zoomLevelId]);

  const getChemistrybetweenPlayers = async (player1: number, player2: number) => {
    await fetchPredictiveChemistryConnection(player1, player2, startLoading, stopLoading, setTeamChemistry, teamChemistry);
  };

  const getAllMissingChemistrys = async () => {
    const allMissingLinks = teamChemistry?.filter((connection) => connection.score === 0);
    startLoading();
    const promises = allMissingLinks.map(async (connection) => {
      return fetchPredictiveChemistryConnection(
        connection.player1,
        connection.player2,
        () => { },
        () => { },
        setTeamChemistry,
        teamChemistry
      );
    });
    await Promise.all(promises);
    if (isSwapActive) {
      const allMissingLinks = swappedTeamChemistry?.filter((connection) => connection.score === 0);
      startLoading();
      const promises = allMissingLinks.map(async (connection) => {
        return fetchPredictiveChemistryConnection(
          connection.player1,
          connection.player2,
          () => { },
          () => { },
          setSwappedTeamChemistry,
          swappedTeamChemistry
        );
      });
      await Promise.all(promises);
      stopLoading();
    } else {
      stopLoading();
    }
  };

  useEffect(() => {
    if (!props.isHeader) {
      setSelectedTeam(Number(props.teamId));
    }
  }, [props.teamId]);

  useEffect(() => {
    if (isSwapActive) {
      setNewAvgAge(Math.trunc(positionResults?.reduce((acc, curr) => acc + curr.age, 0) / 11));
      setNewAttackContribution(Math.trunc(positionResults?.reduce((acc, curr) => acc + curr.contributionValue, 0) / 10));
      setNewPPDA(Number(positionResults?.reduce((acc, curr) => acc + curr.ppda, 0).toFixed(2)));
    } else {
      setAvgAge(Math.trunc(positionResults?.reduce((acc, curr) => acc + curr.age, 0) / 11));
      setAttackContribution(Math.trunc(positionResults?.reduce((acc, curr) => acc + curr.contributionValue, 0) / 10));
      setPPDA(Number(positionResults?.reduce((acc, curr) => acc + curr.ppda, 0).toFixed(2)));
    }
  }, [positionResults]);

  useEffect(() => {
    if (isSwapActive) {
      setNewOverallSFScore(Math.trunc(teamChemistry?.reduce((acc, curr) => acc + curr.score, 0) / teamChemistry?.length));
    } else {
      setOverallSFScore(Math.trunc(teamChemistry?.reduce((acc, curr) => acc + curr.score, 0) / teamChemistry?.length));
    }
  }, [teamChemistry]);

  useEffect(() => {
    setCurrentPlayerView(0);
    setPlayerToSwap(0);
    setPlayerToSwapWith(0);
  }, [selectedTeam]);

  const handleClickOutside = (event: MouseEvent) => {
    if (playerCardRef.current) {
      // @ts-ignore
      if (!playerCardRef.current?.contains(event.target)) {
        setPlayerCardDeatils(undefined);
        setPlayerCardID(0);
      }
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <MainContainer
      isBlurred={props?.isBlurred}
      active={props.toggle}
      isSubSidebarOpen={props.isSubSidebarOpen}
      className="main-container"
      style={{ position: !props.isHeader ? "absolute" : "fixed", overflow: !props.isHeader ? "hidden" : "", zIndex: timeLineDrawerOpen ? "999" : "-1" }}
      //activeTab="Possessions"
    >
      {loading && <LoadingSpinner />}
      {props.isHeader && (
        <ChemistryHeader className="chemistry-header-content">
          <div className="chemistry-header">
            {currentPlayView === "minus" && currentView === "minus" ? (
              <LabelText className="drawer-title">Machine Football - Pitch visualiser</LabelText>
            ) : (
              <LabelText className="drawer-title">{convertToTitleCase(currentView)}</LabelText>
            )}
            <InfoOutlinedIcon
              className="icon"
              onClick={() => {
                setInformationShow(true);
              }}
            />
          </div>
          {/* <SecondaryButton iconType="Bookmark" label="Bookmark pitch state" /> */}
        </ChemistryHeader>
      )}
      <ChemistryHeader
        style={{ background: !props.isHeader ? "transparent" : "", border: !props.isHeader ? "0" : "" }}
        className={`team-selection-wrapper ${(selectedMatch > 0 && zoomLevelId === 1) || selectedTeam > 0 ? "team-selection-above" : ""}`}
      >
        {props.isHeader && (
          <div className="team-selection">
            <LabelText className="team-selection-text">TEAM:</LabelText>
            <CustomButton
              endIcon={<KeyboardArrowDownIcon />}
              color="primary"
              onClick={() => {
                setSidebarOpen(!sidebarOpen);
              }}
            >
              {selectedTeam === 0 && <LabelText className="select-team-label">Select a team</LabelText>}
              <LabelText className="player-search-text">{selectedTeamLabel}</LabelText>
            </CustomButton>
          </div>
        )}
        {selectedMatch > 0 && props.isHeader && zoomLevelId === 1 && (
          <div className="matchInfo-details">
            <div className="match-info-team">
              {/* <img src={matchInfo?.homeTeamUrl} alt="homeTeamUrl" className="home-away-team" /> */}
              <LabelText className="player-search-text">{matchInfo?.homeTeamName}</LabelText>
              <LabelNumber className="home-team-score score">{matchInfo?.homeTeamScore}</LabelNumber>
            </div>
            <div className="match-info-team">
              <LabelNumber className="home-team-score away-team-score score">{matchInfo?.awayTeamScore}</LabelNumber>
              <LabelText className="player-search-text">{matchInfo?.awayTeamName}</LabelText>
              {/* <img src={matchInfo?.awayTeamUrl} alt="awayTeamUrl" className="home-away-team" /> */}
            </div>
          </div>
        )}
        {selectedTeam > 0 && (
          <div className="team-selection">
            <LabelText className="team-selection-text">SHOWING:</LabelText>
            <CustomButton
              color="primary"
              endIcon={<KeyboardArrowDownIcon />}
              onClick={() => {
                setTimeLineDrawerOpen(true);
                fetchMatchTimeline(
                  startLoading,
                  stopLoading,
                  selectedTeam,
                  setMatches,
                  setDisabledButtons,
                  setSelectedSeasonId,
                  selectedSeasonId,
                  false,
                  false,
                  3,
                  setTeamMatchesByMonth,
                  setTimeLineTag,
                  setSeasonName,
                  true
                );
              }}
            >
              <LabelText className="player-search-text">{zoomLevelId === 4 ? "Overall" : timeLineTag}</LabelText>
            </CustomButton>
            <LabelNumber className="season-text"> {zoomLevelId !== 4 && `• ${zoomLevelId === 1 ? matchDate : seasonName}`}</LabelNumber>
          </div>
        )}

        {isDisplayMatchEventInfo && zoomLevelId === 1 && props.isHeader && (
          <MatchEventInfo matchData={matchEventInfo} matchId={selectedMatch} />
        )}
        <div className="matchseletion-button">
          {selectedMatch > 0 && zoomLevelId === 1 && props.isHeader && (
            <SecondaryButton
              iconType={isDisplayMatchEventInfo ? "keyboardarrowup" : "keyboardarrowdown"}
              className="match-card-button"
              onClick={fetchMatchInformation}
            />
          )}
        </div>
      </ChemistryHeader>

      {/* {selectedTeam > 0 && displayedMatches?.length > 0 && ( */}
      <div className="win-loss-information">
        {zoomLevelId === 2 && displayedMatches?.length > 0 && (
          <LabelNumber className="win-loss-info-text">
            {seasonName} • {timeLineTag} • W: {winCount} • D: {drawCount} • L: {lossCount}{" "}
          </LabelNumber>
        )}
      </div>
      <MatchTimeLineWrapper className="match-timeline-wrapper" isTeamSelected={selectedTeam !== 0}>
        {selectedMatch >= 0 && zoomLevelId !== 1 ? (
          <MatchTrackContainer className="match-track-container">
            {selectedTeam > 0 && displayedMatches?.length > 0 && zoomLevelId === 3 && groupIndex !== totalGroups - 1 && (
              <SecondaryButton
                className="arrow-left"
                iconType="keyboardarrowleft"
                onClick={handleLeftClick}
                disabled={groupIndex === totalGroups - 1}
              />
            )}
            <MatchTimeLine
              matches={zoomLevelId === 4 ? [] : displayedMatches}
              timelineDirection={direction}
              onSelectMatchId={handleSelectMatch}
              zoomLevel={zoomLevelId}
              selectedMatchId={previousMatchId}
              teamId={selectedTeam}
            />
            {selectedTeam > 0 && displayedMatches?.length > 0 && zoomLevelId === 3 && groupIndex !== 0 && (
              <SecondaryButton
                className="arrow-right"
                iconType="keyboardarrowright"
                onClick={handleRightClick}
                disabled={groupIndex === 0}
              />
            )}
          </MatchTrackContainer>
        ) : (
          <MatchTrackContainer className="match-track-container">
            <EventTimeLine
              matchId={selectedMatch}
              injuryEvents={injuryEvents!!}
              matchLevelEvents={matchLevelEvents}
              matchEndTime={matchEndTime}
              direction={direction}
            />
          </MatchTrackContainer>
        )}

        <div className="options-here">
          {/* <SecondaryButton iconType="playarrow" disabled={disabledButtons.play} onClick={() => toggleButtonState("play")} /> */}
          <div className="zoom-level-buttons">
            <SecondaryButton
              iconType="keyboardarrowleft"
              disabled={disabledButtons.previous}
              onClick={() => toggleButtonState("previous")}
            />
            <SecondaryButton iconType="remove" disabled={disabledButtons.zoomOut} onClick={() => toggleButtonState("zoomOut")} />
            <SecondaryButton iconType="add" disabled={disabledButtons.zoomIn} onClick={() => toggleButtonState("zoomIn")} />
            <SecondaryButton iconType="keyboardarrowright" disabled={disabledButtons.next} onClick={() => toggleButtonState("next")} />
          </div>
        </div>
      </MatchTimeLineWrapper>
      {isSwapActive &&
        currentView === "systemFit" &&
        alreadyPlottedPlayer.playerID === 0 &&
        swappedPlayerClub?.length! > 0 &&
        swappedPositionResults.length > 1 && (
          <BothPlayerImageContainer className="pw-compare-container">
            <div className="image-container">
              <div className="module-chemistry-player-image">
                <PlayerImageContainer isSelected={currentPlayerView === playerToSwap}>
                  <img
                    src={swappedPositionResults.find((player) => player.playerId === playerToSwap)?.playerImageURL}
                    alt=""
                    onClick={() => setCurrentPlayerView(playerToSwap)}
                  />
                </PlayerImageContainer>
                <img src={currentClubLogo} alt="" className="module-chemistry-club-image" />
              </div>
              <div className="module-chemistry-player-image">
                <PlayerImageContainer isSelected={currentPlayerView === playerToSwapWith}>
                  <img
                    src={positionResults.find((player) => player.playerId === playerToSwapWith)?.playerImageURL}
                    alt=""
                    onClick={() => setCurrentPlayerView(playerToSwapWith)}
                  />
                </PlayerImageContainer>
                <img src={swappedPlayerClub} alt="" className="module-chemistry-club-image" />
              </div>
            </div>
          </BothPlayerImageContainer>
        )}
      <div className="pitch-container-main">
        <div className="pitch-container">
          {selectedTeam > 0 && (
            <div className=" pitch-upper-filters pitch-upper-filters  ">
              <div className="pitch-formation">
                {timelineVisRestrictions[currentView][zoomLevelId] === "allow" && currentView !== "minus" && (
                  <>
                    <LabelText className="team-selection-text">FORMATION</LabelText>
                    <CustomButton
                      endIcon={<KeyboardArrowDownIcon style={{ color: theme.playerColor }} />}
                      color="primary"
                      onClick={() => {
                        setSidebarFormationOpen(!sidebarFormationOpen);
                      }}
                    >
                      <LabelText className="player-given-name">
                        {(currentView === "systemFit" || currentView === "areasOfControl") &&
                          formationData.find((form) => form.id === selectedFormation)?.formation}
                        {(currentView === "passingNetwork" || currentPlayView === "flowOfPlay") &&
                          PNFormationData.find((form) => form.id === selectedPNFormation)?.formation}
                      </LabelText>
                    </CustomButton>
                  </>
                )}
                {zoomLevelId === 1 && currentView === "passingAttack" && (
                  <>
                    <LabelText className="player-given-name">Player selection</LabelText>
                    <CustomButton
                      endIcon={<KeyboardArrowDownIcon style={{ color: theme.playerColor }} />}
                      color="primary"
                      onClick={() => {
                        setPlayerPassingAttackOpen(!playerPassingAttackOpen);
                      }}
                    >
                      <LabelText className="player-given-name">
                        {passingAttackPlayerId === 0
                          ? "Select Player"
                          : playerData.find((player) => player.value === passingAttackPlayerId)?.label}
                      </LabelText>
                    </CustomButton>
                  </>
                )}
              </div>
              <div className="pitch-performance">
                {currentView === "passingNetwork" && (
                  <>
                    <LabelText className="player-given-name">Actual Positioning</LabelText>
                    <Switch
                      id="player-switch"
                      toggled={isActualPositionToggled}
                      onChange={handleActualPositionSwitchClick}
                      source="Filter"
                      isByComparison={false}
                    />
                  </>
                )}
                {currentView === "systemFit" && (
                  <>
                    <LabelText className="player-given-name">Attack Contribution</LabelText>
                    <Switch
                      id="player-switch"
                      toggled={isPerformancSwitchToggled}
                      onChange={handleSwitchClick}
                      source="Filter"
                      isByComparison={false}
                    />
                  </>
                )}
              </div>
            </div>
          )}
        </div>

        <div className="pitch-block-start">
          <div className="pitch-block-left-option">
            <PitchSidebar className="side-btns" isHovered={sidebarHoverItem === "leftUpper"}>
              {sidebarHoverItem === "leftUpper" && <p>TEAM</p>}
              {TeamLayers.map((layer) => (
                <PWBtnContainer
                  className="sidebar-btn-parent"
                  key={layer}
                  isSelected={currentView === layer}
                  onMouseEnter={() => setSidebarHoverItem("leftUpper")}
                  onMouseLeave={() => setSidebarHoverItem(undefined)}
                  onClick={() => handleCurrentView(layer)}
                >
                  <PWSidebarBtns className="sidebar-btn" iconType={layer} isSelected={currentView === layer} />
                  {sidebarHoverItem === "leftUpper" && (
                    <VisNameContainer isSelected={currentView === layer} className="vis-name">
                      {convertToTitleCase(layer === "minus" ? "none" : layer)}
                      <InfoOutlinedIcon
                        className="icon"
                        onClick={() => {
                          setInformationShow(true);
                        }}
                      />
                    </VisNameContainer>
                  )}
                </PWBtnContainer>
              ))}
            </PitchSidebar>
            <PitchSidebar className="side-btns" style={{ top: "280px" }} isHovered={sidebarHoverItem === "leftLower"}>
              {sidebarHoverItem === "leftLower" && <p>PLAY</p>}
              {PlayerLayers.map((layer) => (
                <PWBtnContainer
                  className="sidebar-btn-parent"
                  key={layer}
                  isSelected={currentPlayView === layer}
                  onMouseEnter={() => setSidebarHoverItem("leftLower")}
                  onMouseLeave={() => setSidebarHoverItem(undefined)}
                  onClick={() => handleCurrentPlayView(layer)}
                >
                  <PWSidebarBtns className="sidebar-btn" iconType={layer} isSelected={currentPlayView === layer} />
                  {sidebarHoverItem === "leftLower" && (
                    <VisNameContainer isSelected={currentPlayView === layer} className="vis-name">
                      {convertToTitleCase(layer === "minus" ? "none" : layer)}
                      <InfoOutlinedIcon
                        className="icon"
                        onClick={() => {
                          setInformationShow(true);
                        }}
                      />
                    </VisNameContainer>
                  )}
                </PWBtnContainer>
              ))}
            </PitchSidebar>
          </div>
          <div className="pitch-buttons-wrapper">
            <div className="back-chemistry-btn">
              {(isSwapActive || otherClubPlayer > 0) && currentView === "systemFit" && (
                <BackToTeamChemistryBtn onClick={() => handleReset()}>
                  <img src={ResetIcon} alt="reset icon" />
                  Reset team
                </BackToTeamChemistryBtn>
              )}
              {pnSwapActive && currentView === "passingNetwork" && (
                <BackToTeamChemistryBtn onClick={() => handleReset()}>
                  <img src={ResetIcon} alt="reset icon" />
                  Reset team
                </BackToTeamChemistryBtn>
              )}
              {isIndividualChemistry && currentView === "systemFit" && (
                <BackToTeamChemistryBtn onClick={() => handleReset()}>
                  <KeyboardArrowLeftIcon />
                  Team network
                </BackToTeamChemistryBtn>
              )}
              {isIndividualPassing && currentView === "passingNetwork" && (
                <BackToTeamChemistryBtn onClick={() => handleReset()}>
                  <KeyboardArrowLeftIcon />
                  Team network
                </BackToTeamChemistryBtn>
              )}
              {(teamChemistry?.some((connection) => connection.score === 0) ||
                (isSwapActive && swappedTeamChemistry?.some((connection) => connection.score === 0))) && (
                  <BackToTeamChemistryBtn onClick={() => getAllMissingChemistrys()}>
                    <img src={Simulate} alt="simulate icon" />
                    Predict missing scores
                  </BackToTeamChemistryBtn>
                )}
            </div>
            <Pitch
              //isPattern
              isCorner
              setSidebarPlayerShow={setSidebarPlayerShow}
              isPerformancSwitchToggled={isPerformancSwitchToggled}
              positionResults={currentPlayerView === 0 || currentPlayerView === playerToSwapWith ? positionResults : swappedPositionResults}
              teamChemistry={currentPlayerView === 0 || currentPlayerView === playerToSwapWith ? teamChemistry : swappedTeamChemistry}
              setSwapHoverPlayer={setSwapHoverPlayer}
              setSwapPositionCode={setSwapPositionCode}
              setIsReplacePlayer={setIsReplacePlayer}
              handleIndividualChemistry={handleIndividualChemistry}
              isIndividualChemistry={isIndividualChemistry}
              handleReset={handleReset}
              setIsIndividualChemistry={setIsIndividualChemistry}
              swappedPlayerClub={swappedPlayerClub}
              otherClubPlayer={otherClubPlayer}
              alreadyPlottedPlayer={alreadyPlottedPlayer}
              setPlayerCardID={setPlayerCardID}
              passNetworkPlayers={passNetworkPlayers}
              passNetworkPlayerPasses={passNetworkPlayerPasses}
              currentView={currentView}
              isDisplayInitialRect={isDisplayInitialRect}
              selectedTeam={selectedTeam}
              handleIndividualPassing={handleIndividualPassing}
              isIndividualPassing={isIndividualPassing}
              setIsIndividualPassing={setIsIndividualPassing}
              currentPitchAxis={currentPitchAxis}
              riskMapData={riskMapData}
              currentPlayView={currentPlayView}
              hullData={hullData}
              setIndividualHullPlayer={setIndividualHullPlayer}
              individualHullPlayer={individualHullPlayer}
              flowData={flowData}
              passingAttackData={passingAttackData}
              selectedMatch={selectedMatch}
              getChemistrybetweenPlayers={getChemistrybetweenPlayers}
              formationName={formationData.find((form) => form.id === selectedFormation)?.formation}
              isChemistryDataNotEnough={isChemistryDataNotEnough}
              oldPlayerId={playerToSwap}
              newPlayerId={playerToSwapWith}
              playerCardID={playerCardID}
              handleSwapPlayer={handleSwapPlayer}
            />
            {isIndividualPassing && currentView === "passingNetwork" && (
              <IndividualStatContainer className="individual-stat-container">
                <div>
                  KEY PASSES <span>{individualStat?.totalKeyPasses}</span>
                </div>
                <div>
                  PROGRESSIVE PASSES <span>{individualStat?.totalProgressivePasses}</span>
                </div>
                <div>
                  SMART PASSES <span>{individualStat?.totalSmartPasses}</span>
                </div>
                <div>
                  LONG PASSES <span>{individualStat?.totalLongPasses}</span>
                </div>
                <div>
                  TOTAL PASSES <span>{individualStat?.totalPasses}</span>
                </div>
                <div>
                  ACCURACY <span>{individualStat?.accuracy}%</span>
                </div>
              </IndividualStatContainer>
            )}
            {playerCardID > 0 && playerCardDetails?.playerId! > 0 && (
              <div className="pitch-widget-player-card" ref={playerCardRef}>
                <PlayerLandingCard
                  key={playerCardDetails?.playerId!}
                  playerId={playerCardDetails?.playerId!}
                  givenName={playerCardDetails?.givenName!}
                  familyname={playerCardDetails?.familyname!}
                  playerImageURL={playerCardDetails?.playerImageURL!}
                  isInjured={playerCardDetails?.isInjured!}
                  onLoan={playerCardDetails?.onLoan!}
                  primaryPlayingPosition={playerCardDetails?.primaryPlayingPosition!}
                  age={playerCardDetails?.age!}
                  heightInCM={playerCardDetails?.heightInCM!}
                  playerAttributesByPosition={playerCardDetails?.playerAttributesByPosition!}
                  contributionValue={playerCardDetails?.contributionValue!}
                  performanceValue={playerCardDetails?.performanceValue!}
                  setPlayerCardDeatils={setPlayerCardDeatils}
                  setPlayerCardID={setPlayerCardID}
                  isPlayerInShortlist={playerCardDetails?.isPlayerInShortlist!}
                  isEasternPlayer={playerCardDetails?.isEasternPlayer!}
                  playerLabel={playerCardDetails?.playerLabel!}
                  archetypeName={playerCardDetails?.archetypeName!}
                  archetypeId={playerCardDetails?.archetypeId!}
                />
              </div>
            )}
          </div>

          {currentPlayView === "flowOfPlay" && (
            <div className="pitch-block-right-option">
              <PitchSidebar className="side-btns" isHovered={sidebarHoverItem === "right"}>
                {sidebarHoverItem === "right" && <p>PITCH VIEW</p>}
                {PitchAxisAlyer.map((layer) => (
                  <PWBtnContainer
                    className="sidebar-btn-parent"
                    key={layer}
                    isSelected={currentPitchAxis === layer}
                    onMouseEnter={() => setSidebarHoverItem("right")}
                    onMouseLeave={() => setSidebarHoverItem(undefined)}
                    onClick={() => setCurrentPitchAxis(layer)}
                  >
                    <PWSidebarBtns className="sidebar-btn" iconType={layer} isSelected={currentPitchAxis === layer} />
                    {sidebarHoverItem === "right" && (
                      <VisNameContainer isSelected={currentPitchAxis === layer} className="vis-name">
                        {convertToTitleCase(layer)}
                      </VisNameContainer>
                    )}
                  </PWBtnContainer>
                ))}
              </PitchSidebar>
            </div>
          )}
        </div>
        {isNotification && notificationContent && (
          <PWNotification message={notificationContent} setIsNotification={setIsNotification} className="PWNotificationContainer" />
        )}
        <PitchInfo
          isOpen={informationShow}
          onClose={() => {
            setSidebarPlayerShow(false);
          }}
        />
      </div>

      <TeamSelectDrawer
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        searchTerm={searchTerm}
        handleInputChange={handleInputChange}
        handleTeamClear={handleTeamClear}
        setOptionsShow={setOptionsShow}
        inputRef={inputRef}
        handleInputKeyDown={handleInputKeyDown}
        optionsShow={optionsShow}
        teams={teams}
        handleTeamChange={handleTeamChange}
      />
      <FormationSelectDrawer
        sidebarFormationOpen={sidebarFormationOpen}
        setSidebarFormationOpen={setSidebarFormationOpen}
        formationData={currentView === "systemFit" || currentView === "areasOfControl" ? formationData : PNFormationData}
        theme={theme}
        selectedFormation={currentView === "systemFit" || currentView === "areasOfControl" ? selectedFormation : selectedPNFormation}
        setSelectedFormation={
          currentView === "systemFit" || currentView === "areasOfControl" ? setSelectedFormation : handlePNFormationChange
        }
        handleFormationChange={handleFormationChange}
      />
      <PlayerSelectDrawer
        sidebarPlayerShow={sidebarPlayerShow}
        setSidebarPlayerShow={setSidebarPlayerShow}
        isReplacePlayer={isReplacePlayer}
        setIsReplacePlayer={setIsReplacePlayer}
        playerFromSamePositions={playerFromSamePositions}
        substitutePlayerOptions={substitutePlayerOptions}
        handleSwapPlayer={handleSwapPlayer}
        otherSquadMembers={otherSquadMembers}
        currentView={currentView}
        handleSearchChange={handleSearchChange}
        handleClear={handleClear}
        theme={theme}
        searchText={searchText}
        searchData={searchData}
        handleSelect={handleSelect}
      />
      <ChemistryInfo informationShow={informationShow} setInformationShow={setInformationShow} />
      <Timeline
        isOpen={timeLineDrawerOpen}
        onClose={() => setTimeLineDrawerOpen(false)}
        teamId={selectedTeam}
        seasonData={seasonData}
        teamMatchByMonthsData={teamMatchesByMonth}
        onConfirm={handleConfirm}
        zoomLevelId={zoomLevelId}
        selectedSeasonId={selectedSeasonId}
      />
      <SelectPlayerPassingAttackDrawer
        playerPassingAttackDrawerOpen={playerPassingAttackOpen}
        setPlayerPassingAttackDrawerOpen={setPlayerPassingAttackOpen}
        playerData={playerData}
        theme={theme}
        passingAttackPlayerId={passingAttackPlayerId}
        setPassingAttackPlayerId={setPassingAttackPlayerId}
        onConfirm={handlePlayerSelection}
      />
      {!sidebarPlayerShow &&
        !playerPassingAttackOpen &&
        !timeLineDrawerOpen &&
        !sidebarFormationOpen &&
        currentView === "systemFit" &&
        timelineVisRestrictions[currentView][zoomLevelId] === "allow" && (
          <SummaryBar
            style={{ marginLeft: !props.isHeader ? "-40px" : "" }}
            isSwapActive={isSwapActive}
            selectedTeam={selectedTeam}
            avgAge={avgAge}
            newAvgAge={newAvgAge}
            overallSFScore={overallSFScore}
            newOverallSFScore={newOverallSFScore}
            newAttackContribution={newAttackContribution}
            attackContribution={attackContribution}
            newPPDA={newPPDA}
            ppda={ppda}
            loading={loading}
          />
        )}
      {displayCardNotification && (
        <PWNotification
          message={cardNotificationContent}
          setIsNotification={() => seIsDisplayCardNotification(false)}
          isDisplayCloseIcon={true}
          className="player-filter-notification add-similar-notification"
        />
      )}
    </MainContainer>
  );
};

export default Chemistry;
